import { NavLink } from 'react-router-dom'
import { NAV } from './nav'
import { Icon } from '../components/Icon'
import { useUI } from '../store/ui'
import { useSession } from '../store/session'
import { matchPermission } from '../rbac/permissions'
import { BRAND } from '../brand'

export function Sidebar() {
  const { navCollapsed, toggleNav } = useUI()
  const me = useSession((s) => s.me)
  const perms = me?.permissions ?? []

  return (
    <aside className={'sidebar' + (navCollapsed ? ' collapsed' : '')}>
      <div className="sb-head">
        <div className="sb-logo">{BRAND.name[0]}</div>
        <span className="sb-name">{BRAND.name}</span>
      </div>
      <nav className="sb-nav">
        {NAV.map((g) => {
          const items = g.items.filter((it) => matchPermission(perms, it.perm))
          if (items.length === 0) return null
          return (
            <div className="sb-group" key={g.label}>
              <div className="sb-group-label">{g.label}</div>
              {items.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  end={it.to === '/'}
                  title={it.label}
                  className={({ isActive }) => 'sb-item' + (isActive ? ' active' : '')}
                >
                  <Icon name={it.icon} />
                  <span className="lbl">{it.label}</span>
                  {it.badge ? <span className="sb-badge">{it.badge}</span> : null}
                </NavLink>
              ))}
            </div>
          )
        })}
      </nav>
      <div className="sb-foot">
        <button className="sb-item" onClick={toggleNav} title="Collapse">
          <Icon name={navCollapsed ? 'chevR' : 'chevL'} />
          <span className="lbl">Collapse</span>
        </button>
      </div>
    </aside>
  )
}
